import { ShellPartnersComponent } from '@app/shell-partners/shell-partners.component';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { PermissionGuard } from '@app/guards/permission.guard';
import { Route, Routes } from '@angular/router';

export class ShellPartners {
	static childRoutes(routes: Routes): Route {
		return {
			data: { permissionKey: 'partner-portal' },
			path: AppRouteHelper.shellPartnersPrefix,
			component: ShellPartnersComponent,
			canActivate: [PermissionGuard],
			canActivateChild: [PermissionGuard],
			children: routes.map((route: Route) => {
				route.data = { permissionKey: 'partner-portal' };
				return route;
			}),
		};
	}
}
